import { QueryFilter } from '@queryfilter/data/usecases';
import { AxiosQueryFilterClient } from '@queryfilter/infra/protocols';

const queryFilter = new QueryFilter(new AxiosQueryFilterClient());
export default queryFilter;
